import React, { createContext, Component } from "react";
import {multiLang} from '../mockdata/Translations/LangIndex';
export const SettingContext = createContext();

export default class SettingContextProvider extends Component {
    
    state = {
        language: localStorage.language ? localStorage.getItem("language") : 'English',
        translatedContent: localStorage.language ? multiLang[localStorage.getItem("language")] : multiLang.English,
        currency: localStorage.currency ? localStorage.getItem("currency") : 'Euro',
        showDialogue: false
    }
    toggleSetting = (lang, icCurrency) => {
        this.setState({ language: lang, translatedContent: multiLang[lang], currency: icCurrency, showDialogue: true });
        localStorage.setItem("language", lang);
        localStorage.setItem("currency", icCurrency);
    }
    closeDialogue = () => {
        this.setState({
            showDialogue: false
        })
    }

    render() {
        return (
            <SettingContext.Provider value={{ ...this.state, toggleSetting: this.toggleSetting, closeDialogue: this.closeDialogue }}>
                {this.props.children}
            </SettingContext.Provider>
        )
    }

}